import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cartProducts: []
  },
  getters: {
    cartProducts: state => {
      return state.cartProducts;
    }
  },
  mutations: {
    ADD_CART_LOCAL: (state, product) => {
      state.cartProducts.push(product);
      localStorage.setItem("was-cart", JSON.stringify(state.cartProducts));
    },
    EDIT_CART_LOCAL: (state, product) => {
      let i = state.cartProducts
        .map(item => item.itemId)
        .indexOf(product.itemId); // find index of your object
      // state.cartProducts.splice(i, 1) // remove it from array
      state.cartProducts[i] = product; // update
      localStorage.setItem("was-cart", JSON.stringify(state.cartProducts));
    },
    REMOVE_CART_LOCAL: (state, product) => {
      let i = state.cartProducts
        .map(item => item.itemId)
        .indexOf(product.itemId); // find index of your object
      state.cartProducts.splice(i, 1); // remove it from array
      localStorage.setItem("was-cart", JSON.stringify(state.cartProducts));
    },
    CLEAR_CART: state => {
      state.cartProducts = [];
      localStorage.removeItem("was-cart");
    },
    SET_CART_PRODUCTS: (state, products) => {
      state.cartProducts = [];
      state.cartProducts = products;
    }
  },
  actions: {}
});
